import sa from 'sa-sdk-javascript'

export default sa
